import { API } from "@/api";

export const COMM_CD_GROUP_IDS = {
    GS25_FAQ_CTG_CD: "GS25_FAQ_CTG_CD",
    GS25_FRAN_TYPE_CD: "GS25_FRAN_TYPE_CD",
    GS25_PSN_DV_CD: "GS25_PSN_DV_CD",
    GS25_CONSL_ACEPT_STAT_CD: "GS25_CONSL_ACEPT_STAT_CD",
    GS25_BRFS_ACEPT_STAT_CD: "GS25_BRFS_ACEPT_STAT_CD",
    GS25_BRFS_REGN_DV_CD: "GS25_BRFS_REGN_DV_CD",
    GS25_SWTCH_CONSL_ACEPT_STAT_CD: "GS25_SWTCH_CONSL_ACEPT_STAT_CD",
    GSF_FRAN_TYPE_CD: "GSF_FRAN_TYPE_CD",
    GSF_PSN_DV_CD: "GSF_PSN_DV_CD",
    GSF_CONSL_ACEPT_STAT_CD: "GSF_CONSL_ACEPT_STAT_CD",
    GSF_BRFS_ACEPT_STAT_CD: "GSF_BRFS_ACEPT_STAT_CD",
    GSF_BRFS_REGN_DV_CD: "GSF_BRFS_REGN_DV_CD",
    GSF_LOCA_PROPOS_CONSL_ACEPT_STAT_CD: "GSF_LOCA_PROPOS_CONSL_ACEPT_STAT_CD",
    NWSRM_DV_CD: "NWSRM_DV_CD",
    ANSWR_TPL_DV_CD: "ANSWR_TPL_DV_CD",
    REPORT_DV_CD: "REPORT_DV_CD",
    REPORT_CTG_CD: "REPORT_CTG_CD",
    MBS_FAQ_CTG_CD: "MBS_FAQ_CTG_CD",
    INQRY_BZUT_DV_CD: "INQRY_BZUT_DV_CD",
    INQRY_BZUT_TYPE_CD: "INQRY_BZUT_TYPE_CD",
    INQRY_STAT_CD: "INQRY_STAT_CD",
    INQRY_INFLW_CD: "INQRY_INFLW_CD",
    INQRY_TYPE_CD: "INQRY_TYPE_CD",
    BZ_DV_CD: "BZ_DV_CD",
    CONSL_DV_CD: "CONSL_DV_CD",
    CONSL_TYPE_CD: "CONSL_TYPE_CD",
    DECLR_TYPE_CD: "DECLR_TYPE_CD",
    EMAIL_SMS_DSPT_DV_CD: "EMAIL_SMS_DSPT_DV_CD",
    SCH_STAT_CD: "SCH_STAT_CD",
    ISTR_INQRY_ACEPT_STAT_CD: "ISTR_INQRY_ACEPT_STAT_CD",
    ISTR_CONSL_ANSWR_DV_CD: "ISTR_CONSL_ANSWR_DV_CD",
    STR_CHRC_CD: "STR_CHRC_CD",
    ATACH_FILE_DV_CD: "ATACH_FILE_DV_CD",
    RCMD_STR_DV_CD: "RCMD_STR_DV_CD",
    RCMD_STR_STAT_CD: "RCMD_STR_STAT_CD",
    HNDL_ATC_CD: "HNDL_ATC_CD",
    POPUP_HIDDN_TYPE_CD: "POPUP_HIDDN_TYPE_CD",
    POPUP_POSTN_ASGN_CD: "POPUP_POSTN_ASGN_CD",
    CVS_WORK_CARER_CD: "CVS_WORK_CARER_CD",
    HMPG_TRMS_DV_CD: "HMPG_TRMS_DV_CD",
    REPLY_TYPE_CD: "REPLY_TYPE_CD",
    SM_WORK_CARER_CD: "SM_WORK_CARER_CD",
    IVST_PSBL_AMT_DV_CD: "IVST_PSBL_AMT_DV_CD",
    INCOM_AMT_DV_CD: "INCOM_AMT_DV_CD"
};

const toCommCdItem = (item = {}) => ({
    title: item.commCdNm || item.cdNm || item.cdId || item.commCd || item.value || "",
    value: item.cdId || item.commCd || item.cd || item.value || "",
});

const getCommCdResponseItems = (data = []) => {
    if (Array.isArray(data)) {
        return data;
    }

    if (Array.isArray(data?.data)) {
        return data.data;
    }

    if (Array.isArray(data?.list)) {
        return data.list;
    }

    if (Array.isArray(data?.content)) {
        return data.content;
    }

    return [];
};

export const makeCommCdItems = (data = []) =>
    getCommCdResponseItems(data).map(toCommCdItem).filter((item) => item.value !== "");

export const loadCommCdGroupItems = async (groupMap = {}) => {
    const entries = await Promise.all(
        Object.entries(groupMap).map(async ([key, commGrpCd]) => {
            try {
                const response = await API.commonAPI.selectCommCdByGrpId({ commGrpCd });
                const items = makeCommCdItems(response?.data);
                return [key, items];
            } catch {
                return [key, []];
            }
        })
    );

    return Object.fromEntries(entries);
};
